import React from "react";
import {
  makeStyles,
  createStyles,
  Theme,
  Grid,
  AppBar,
  Container,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cFooterTitle: {
      position: "relative",
      textAlign: "center",
      marginBottom: 64,
      "&::before": {
        content: '" "',
        top: "50%",
        left: 0,
        // marginTop: "-0.815rem",
        width: "calc(33.333333% - 40px)",
        height: 1,
        background: "#000000",
        position: "absolute",
        boxSizing: "inherit",
      },
      "&::after": {
        content: '" "',
        top: "50%",
        right: 0,
        // marginTop: "-0.815rem",
        width: "calc(33.333333% - 40px)",
        height: 1,
        background: "#000000",
        position: "absolute",
        boxSizing: "inherit",
      },
    },
    aLink: {
      color: "black",
      fontFamily: "Noto Sans KR",
      fontSize: 16,
      fontWeight: 500,
      letterSpacing: 4,
    },
    bottomSec: {
      display: "flex",
    },
    linkSec: {
      // textAlign: "center",
      fontSize: 12,
      fontWeight: 900,
      color: "black",
      display: "flex",

      paddingBottom: 16,
    },
    iconSec: {
      display: "flex",
    },
    wayLink: {
      color: "black",
    },
    addressStrong: { fontStyle: "normal", paddingRight: 8, fontSize: 12 },
    addresstext: { fontWeight: 500, margin: 0 },
    footerPadding: {
      paddingBottom: 64,
      [theme.breakpoints.down("xs")]: {
        paddingBottom: 0,
      },
    },
  })
);

function MobileFooter() {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Container style={{ padding: 32 }}>
      <Grid
        xs={12}
        item
        container
        justify={"center"}
        className={classes.iconSec}
        style={{ paddingBottom: 16 }}
      >
        <div
          className={classes.linkSec}
          style={{ paddingRight: 24, paddingLeft: 24 }}
        >
          <a
            href="https://www.facebook.com/%EB%85%B8%EB%8F%99%EC%9D%B8%EA%B6%8C%EB%AC%B8%ED%99%94%EC%A0%9C-111993953918341/"
            className={classes.aLink}
          >
            <FontAwesomeIcon
              icon={faFacebook}
              // size={"4x"}
              size={!matches ? "4x" : "2x"}
            ></FontAwesomeIcon>
          </a>
        </div>
        <div
          className={classes.linkSec}
          style={{ paddingRight: 24, paddingLeft: 24 }}
        >
          <a
            href="https://www.instagram.com/laborhumanright/"
            className={classes.aLink}
          >
            <FontAwesomeIcon
              icon={faInstagram}
              size={!matches ? "4x" : "2x"}
            ></FontAwesomeIcon>
          </a>
        </div>
        <div
          className={classes.linkSec}
          style={{ paddingRight: 24, paddingLeft: 24 }}
        >
          <a
            href="https://www.youtube.com/channel/UC683ge_oW8OGsXAbAGXEoxg/featured"
            className={classes.aLink}
          >
            <FontAwesomeIcon
              icon={faYoutube}
              size={!matches ? "4x" : "2x"}
            ></FontAwesomeIcon>
          </a>
        </div>
      </Grid>

      <Grid xs={12} item>
        <Grid xs={12} container item>
          <Grid className={classes.linkSec} style={{ paddingRight: 16 }}>
            <em className={classes.addressStrong}>주소</em>
            <div className={classes.addresstext}>
              부산 부산진구 서면로 9 지하 1층
            </div>
          </Grid>
          <Grid className={classes.linkSec}>
            <em className={classes.addressStrong}>전화번호</em>
            <div className={classes.addresstext}>051-803-8746</div>
          </Grid>
        </Grid>
        <Grid container item>
          <Grid className={classes.linkSec} style={{ paddingRight: 16 }}>
            <em className={classes.addressStrong}>주관</em>
            <div className={classes.addresstext}>(사)노동인권연대</div>
          </Grid>
          <Grid className={classes.linkSec}>
            <div className={classes.addressStrong}>후원</div>
            <div className={classes.addresstext} style={{}}>
              <img
                style={{ width: 100 }}
                src={"/images/support/busanbankLogo.png"}
              ></img>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default MobileFooter;
